import useUserPlanData from "@/components/Root/hooks/useUserPlanData";

import { useCheckoutDataQuery } from "@/components/Root/hooks/useCheckoutDataQuery";
import {
  LOCALISED_PRICING_SOURCE,
  useLocalisedPricing,
} from "./useLocalisedPricing";

// `useLocalisedPricing` with its signals already sourced, off page-wide cached
// queries, so callers that only need the answer don't re-plumb them.
export function useIsLocalisedPricing() {
  const { data: userPlanData } = useUserPlanData();
  const { data: userCheckoutData } = useCheckoutDataQuery();

  return useLocalisedPricing({
    source: LOCALISED_PRICING_SOURCE.METADATA,
    planCurrency: userCheckoutData?.planCards?.[0]?.pricing.currency,
    userCountryCode: userPlanData?.country_code,
  });
}
